import { put, select } from 'redux-saga/effects';
import type { SagaIterator } from 'redux-saga';
import { selectors, withOffset } from '../../Stream';
import { getBrowseDeviationStreamId } from '../helpers';
import { getSearchQuery } from '../selectors';

export default function* (): SagaIterator {
  const searchQuery: ReturnType<typeof getSearchQuery> = yield select(state =>
    getSearchQuery(state)
  );

  const streamId = getBrowseDeviationStreamId(searchQuery);

  const isFetching: ReturnType<typeof selectors.isFetching> = yield select(
    selectors.isFetching,
    streamId
  );
  if (isFetching) {
    return;
  }

  yield put(withOffset.actions.fetch(streamId));
}
